var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "sidebar-mobile" }, [
        _c(
          "div",
          { staticClass: "sidebar-mobile__container" },
          [
            _vm.canContactTeam
              ? [
                  _vm.rm
                    ? _c("ContactTeamMobileItem", {
                        attrs: { item: _vm.rm, "modal-key": "contactRM" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.am
                    ? _c("ContactTeamMobileItem", {
                        attrs: { item: _vm.am, "modal-key": "contactAM" }
                      })
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0)
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("input", { attrs: { type: "checkbox", id: "toggle-menu" } }),
      _vm._v(" "),
      _c("NavMenuMobile")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-mobile__menu-btn" }, [
      _c("label", { attrs: { for: "toggle-menu" } }, [_vm._v("MENU")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }